<template lang="html">
  <masked-input
    type="text"
    class="text-left form-control"
    :class="customClass"
    :id="id"
    v-model="cnpj"
    @change="callChange"
    @keyup="callKeyUp"
    @blur="searchCNPJ(cnpj)"
    :placeholder="placeholder"
    :mask="[
      /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
      /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
      /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/',
      /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
      /\d/, /\d/
    ]"
    :guide="false"
  ></masked-input>
</template>

<script>
import { getCnpj } from '@/utils';
import MaskedInput from 'vue-text-mask';

export default {
  name: 'input-cnpj',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: '00.000.000/0000-00',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
    updateCompanyData: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    cnpj: {
      get() {
        return this.model;
      },
      set(val) {
        const localVal = val ? val.toUpperCase() : val;
        this.$emit('update:model', localVal);
      },
    },
    customClass() {
      if (this.state === null) return null;
      const valid = this.state ? 'is-valid' : 'is-invalid';
      return valid;
    },
  },
  mounted() {
    this.cnpj = this.model;
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    searchCNPJ(cnpj) {
      if (cnpj && cnpj.length === 18) {
        getCnpj(cnpj).then( data => {
          this.updateCompanyData(data);
        });
      }
    },
  },
};
</script>
